import { Dialog, DialogContent, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';

interface ITemporaryDialogProps {
  isOpen: boolean;
  message: string;
  // eslint-disable-next-line react/require-default-props
  imagePath?: string;
  // eslint-disable-next-line react/require-default-props
  onClose?: () => void;
}

export default function TemporaryDialog({
  isOpen,
  imagePath = '/static/images/upload-cloud.svg',
  message = 'Scenario Created Successfully',
  onClose
}: ITemporaryDialogProps) {
  useEffect(() => {
    setTimeout(() => {
      if (isOpen) {
        onClose();
      }
    }, 1500);
  }, []);
  return (
    <Dialog open={isOpen} onClose={() => onClose()}>
      <DialogContent
        sx={{ padding: 2 }}
        style={{ width: '320px', height: '130px', textAlign: 'center' }}
      >
        <Grid container justifyContent='center'>
          <img style={{ maxWidth: '80px' }} src={imagePath} alt='success' />
        </Grid>
        <Typography variant='h5' style={{ marginTop: '10px' }}>
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
